var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(-552 -4925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1162",
    "data-name": "Rectangle 1162",
    width: 77,
    height: 77,
    transform: "translate(552 4925)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Art",
    transform: "translate(567 4933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M465.942,130.711c2.345-4.585-1.305-8.913-3.481-10.936a9.637,9.637,0,0,1-2.68,5.432,4.724,4.724,0,0,0-1.348,3.462,4.53,4.53,0,0,0,.824,2.185,1.229,1.229,0,0,0,1.014.536h4.573a1.239,1.239,0,0,0,1.1-.68Z",
    transform: "translate(-420.192 -111.452)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M179.65,61.152v53.319a3.609,3.609,0,0,0,3.567,3.643h10.4v-60.6h-10.4a3.61,3.61,0,0,0-3.567,3.643Zm7,47.085a4.505,4.505,0,1,1,4.41-4.5A4.458,4.458,0,0,1,186.646,108.237Zm0-15.922a4.505,4.505,0,1,1,4.41-4.5A4.458,4.458,0,0,1,186.646,92.315Zm0-24.93a4.505,4.505,0,1,1-4.41,4.5A4.458,4.458,0,0,1,186.646,67.386Z",
    transform: "translate(-179.65 -57.509)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M311.41,57.512h-10.4v60.6h10.4a3.609,3.609,0,0,0,3.567-3.643V61.155a3.609,3.609,0,0,0-3.566-3.643Zm-3.429,50.727a4.505,4.505,0,1,1,4.41-4.5A4.458,4.458,0,0,1,307.981,108.239Zm0-15.922a4.505,4.505,0,1,1,4.41-4.5A4.458,4.458,0,0,1,307.981,92.317Zm0-15.922a4.505,4.505,0,1,1,4.41-4.5A4.458,4.458,0,0,1,307.981,76.4Z",
    transform: "translate(-284.289 -57.512)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M468.878,223.845a.527.527,0,0,0-.1-.158.513.513,0,0,0-.379-.166h-6.44a.511.511,0,0,0-.379.166l0,0a.51.51,0,0,0-.134.386l2.657,35.734a1.082,1.082,0,0,0,2.159,0l2.657-35.734A.527.527,0,0,0,468.878,223.845Z",
    transform: "translate(-422.809 -200.069)",
    fill: "#016dd9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/Paint.2d3a388ce3bf6cbdad6cc6137c18849a.svg";
export { ForwardRef as ReactComponent };